import {Directive, EnvironmentInjector, inject, Injector, Input, OnInit, ViewContainerRef} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {destroy$} from '../../../../../components/destroyable';
import {DynamicComponentFactoryService, DynamicComponentRef} from '../../../../../components/dynamic-component';
import {Widget} from '../../../../../components/layout/widget/widget';

@Directive({
    selector: 'widget-settings-body-renderer',
    standalone: false
})
export class WidgetSettingsBodyRendererDirective implements OnInit {

    @Input()
    public widget: Widget;

    public readonly destroy$ = destroy$();

    private settingsComponentRef: DynamicComponentRef<any>;

    private readonly dynamicComponentFactoryService = inject(DynamicComponentFactoryService);
    private readonly viewContainerRef = inject(ViewContainerRef);
    private readonly injector = inject(Injector);
    private readonly environmentInjector = inject(EnvironmentInjector);

    public ngOnInit(): void {
        this.widget.implementationInstance.ready$.pipe(
            takeUntil(this.destroy$)
        ).subscribe({
            next: isReady => isReady ? this.createComponent() : this.destroyComponent(),
            complete: () => this.destroyComponent()
        });
    }

    private createComponent(): void {
        const injector = Injector.create({
            name: `${this.widget.widgetDescription.widgetTypeId} Settings Component Injector`,
            parent: this.injector,
            providers: [
                {
                    provide: Widget,
                    useValue: this.widget
                }
            ]
        });

        this.settingsComponentRef = this.dynamicComponentFactoryService.create(
            this.widget.widgetDescription.widgetSettingsComponentType,
            {
                injector,
                environmentInjector: this.environmentInjector,
                place: {
                    viewContainerRef: this.viewContainerRef
                },
                configure: {
                    widget: this.widget
                }
            }
        );
    }

    private destroyComponent(): void {
        if (this.settingsComponentRef) {
            this.settingsComponentRef.destroy();
            this.settingsComponentRef = null;
        }
    }

}
